import tenantData from '@data';
import tenantConstants from '@constants';
import tenantRoutes from '@routes';
import tenantUtils from '@utils';
import cx from 'clsx';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ListingHealth from '../../../../../components/listing-health/listing-health';
import { useApplyProductModalData } from '../../../../../hooks';
import { actionButtonQualityWidgetClickEvent } from '../../../../../services/analyticsService';
import { HealthTag } from '../../../../../components/listing-health/styled';
import TenantComponents from '@components';

const Health = (props) => {
  const { listingsData } = props;
  const { t } = useTranslation();
  const deductionModalRef = useRef();
  const navigate = useNavigate();
  const isMobile = useSelector((state) => state.app.AppConfig.isMobile);
  const { user } = useSelector((state) => state.app.loginUser);
  const query = new URLSearchParams(location.search);
  const statusId = query.get('q[status_id_eq]');

  const {
    confirmationLoading,
    selectedPaymentOption,
    paymentOptions,
    action,
    onSuccessQuotaCreditModal,
    getDeduction,
    onChangePaymentOption,
    onCancelModal,
  } = useApplyProductModalData(user, deductionModalRef);

  const getTagColor = (color) => {
    switch (color) {
      case 'high':
        return 'success';
      case 'low':
        return 'error';
      case 'medium':
        return 'warning';
      default:
        return 'warning';
    }
  };

  const getScoreIcon = (color, percentage) => {
    return (
      <HealthTag
        className={cx('fw-700 fz-14 text-center')}
        style={{ width: '50px', paddingBlock: isMobile ? '2px' : '5px' }}
        color={getTagColor(color)}
      >
        {percentage}%
      </HealthTag>
    );
  };

  const healthData = [
    {
      title: t('FRESHNESS'),
      subTitle: tenantUtils.getLocalisedString(props, 'age_title'),
      message: tenantUtils.getLocalisedString(props, 'age_message'),
      status: props?.age_percentage_score,
      color: props?.age_classification,
      scoreIcon: getScoreIcon(props?.age_classification, props?.age_percentage_score),

      ...(tenantConstants.ALLOW_LISTING_REFRESH
        ? {
            button: t('Refresh'),
            showButton: listingsData?.productsInfo?.refresh?.is_applicable && props?.age > 3,
            onClick: () => {
              const action = tenantData.getListingActions('refresh');
              getDeduction(action?.actionType, listingsData.platforms.data[0], action);
            },
          }
        : {}),
    },
    {
      title: t('UNIQUE IMAGES'),
      subTitle: tenantUtils.getLocalisedString(props, 'unique_images_title'),
      message: tenantUtils.getLocalisedString(props, 'unique_images_message'),
      status: props?.unique_images_percentage_score,
      color: props?.unique_images_classification,
      scoreIcon: getScoreIcon(props?.unique_images_classification, props?.unique_images_percentage_score),
      button: t('Add Images'),
      showButton: props?.unique_images_percentage_score === 100 ? false : true,
      onClick: () => {
        actionButtonQualityWidgetClickEvent(user, statusId, 'add-images', props);
        const path = `${tenantRoutes.app().post_listing.path}/${listingsData.id}#images`;
        navigate(path);
      },
    },
    {
      title: t('FEATURES'),
      subTitle: tenantUtils.getLocalisedString(props, 'features_title'),
      message: tenantUtils.getLocalisedString(props, 'features_message'),
      status: props?.features_percentage_score,
      color: props?.features_classification,
      scoreIcon: getScoreIcon(props?.features_classification, props?.features_percentage_score),
      button: t('Add Amenities'),
      showButton: props?.features_percentage_score === 100 ? false : true,
      onClick: () => {
        actionButtonQualityWidgetClickEvent(user, statusId, 'add-amenities', props);
        const path = `${tenantRoutes.app().post_listing.path}/${listingsData.id}#amenities`;
        navigate(path);
      },
    },
  ];

  return (
    <>
      {props.hidePopover ? (
        getScoreIcon(props?.overall_classification, props?.overall_percentage_score)
      ) : (
        <ListingHealth
          dataToShow={healthData}
          overallClassification={props?.overall_classification}
          overallScoreIcon={getScoreIcon(props?.overall_classification, props?.overall_percentage_score)}
          overallPercentageScore={props?.overall_percentage_score}
          statusId={statusId}
          headerBg={
            props?.overall_classification == 'high'
              ? 'success-color'
              : props?.overall_classification == 'medium'
                ? 'warning-color'
                : 'error-color'
          }
        />
      )}
      <TenantComponents.QuotaCreditModal
        ref={deductionModalRef}
        title={action?.applicableProduct?.requestTitle}
        action={action}
        okText={action?.isSufficient ? 'Submit' : 'Continue'}
        onSuccess={onSuccessQuotaCreditModal}
        onCancel={onCancelModal}
        loading={confirmationLoading}
        selectedPaymentOption={selectedPaymentOption}
        paymentOptions={paymentOptions}
        onChangePaymentOption={onChangePaymentOption}
        showInsufficientCreditsAlert
        showInfoMessage
        hideDataTable
      />
    </>
  );
};

export default Health;
